import {SESSION_RECORD} from '../../Types/SessionRecord';

export const sessionRecord = (payload) => ({
    type: SESSION_RECORD,
    payload,
})